import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

// Components
import ChatDashboard from './components/ChatDashboard';
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/layout/Header';
import AnalyticsDashboard from './components/analytics/AnalyticsDashboard';
import UserManagement from './components/users/UserManagement';
import supabase from './lib/supabase';

function App() {
  const [connectionStatus, setConnectionStatus] = useState({
    connected: false,
    message: 'Checking connection...'
  });

  // Check connection to Supabase on app load
  useEffect(() => {
    const checkConnection = async () => {
      try {
        const { data, error } = await supabase
          .from('log_percakapan_urology_expert')
          .select('id_whatsapp')
          .limit(1);

        if (error) throw error;

        setConnectionStatus({
          connected: true,
          message: 'Connected to Supabase'
        });
      } catch (error) {
        console.error('Supabase connection error:', error);
        setConnectionStatus({
          connected: false,
          message: `Failed to connect to Supabase: ${error.message}`
        });
      }
    };

    checkConnection();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <>
                    <Header connectionStatus={connectionStatus} />
                    <ChatDashboard />
                  </>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute>
                  <>
                    <Header connectionStatus={connectionStatus} />
                    <AnalyticsDashboard />
                  </>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <>
                    <Header connectionStatus={connectionStatus} />
                    <UserManagement />
                  </>
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;